import React from 'react';

export const RegionModal = {
  title: 'Region',
  body: (
    <div>
      <p>
        Regional boundaries defined as follows:
      </p>
      <p>
        <p>
          <ul>
            <li>150 - North America and Hawaii:</li>
            <ul>
              <li>(Canada, Mexico,USA)</li>
            </ul>
            <li>100 - Central America:</li>
            <ul>
              <li>(Costa Rica,El Salvador,Guatemala,Honduras,Nicaragua,Panama)</li>
            </ul>
            <li>90 - Caribbean:</li>
            <ul>
              <li>
                (Antigua and Barbuda, Barbados, Cuba, Dominican Republic, French Guiana, Grenada, Guadeloupe, Haiti, Jamaica, Martinique, Puerto Rico, Saint Lucia, Saint Vincent and the Grenadines, Trinidad and Tobago, U.S. Virgin Islands)
              </li>
            </ul>
            <li>160 - South America:</li>
            <ul>
              <li>(Argentina,Bolivia,Brazil,Chile,Colombia,Ecuador,Peru,Venezuela)</li>
            </ul>
            <li>70 - Atlantic Ocean</li>
            <li>15 - Northern Africa:</li>
            <ul>
              <li>(Algeria, Egypt, Libya, Morocco, Sudan, Tunisia)</li>
            </ul>
            <li>10 - Central, Western and S. Africa:</li>
            <ul>
              <li>
                Burundi, Cameroon, Canary Islands,
                Central African Republic, Congo, Coite DIvoire, Ethiopia, Gabon, Ghana,
                Guinea, Guyana, Malawi, Mozambique, Rwanda, Sierra Leone, South Africa
                Tanzania, Togo, Uganda, Zambia)
              </li>
            </ul>
            <li>20 - Antarctica</li>
            <li>120 - Northern and Western Europe:</li>
            <ul>
              <li>
                (Austria, Belgium, France, Germany, Iceland, Netherlands, Switzerland, United Kingdom)
              </li>
            </ul>
            <li>130 - Southern Europe:</li>
            <ul>
              <li>
                (Azores (Portugal), Black Sea, Bosnia-Herzegovina, Croatia, Cyprus, Greece, Italy, Macedonia, Portugal, Serbia and Montenegro, Slovenia, Spain)
              </li>
            </ul>
            <li>110 - Eastern Europe:</li>
            <ul>
              <li>
                (Bulgaria, Hungary, Poland, Romania, Slovakia, Ukraine)
              </li>
            </ul>
            <li>140 - Middle East:</li>
            <ul>
              <li>
                (Iran,
                Iraq,
                Israel,
                Jordan,
                Lebanon,
                Saudi Arabia,
                Syria,
                Turkey,
                Yemen)
              </li>
            </ul>
            <li>40 - Central Asia and Caucasus:</li>
            <ul>
              <li>
                (Afghanistan,
                Armenia,
                Azerbaijan,
                Black Sea,
                Western China,
                Georgia,
                Kazakhstan,
                Kyrgyzstan,
                Mongolia,
                Russia,
                Tajikistan, Turkmenistan, Uzbekistan)
              </li>
            </ul>
            <li>30 - East Asia:</li>
            <ul>
              <li>(Eastern China, East China Sea, Japan, Japan Sea, North Korea, South Korea, Taiwan, Yellow Sea)</li>
            </ul>
            <li>60 - S. and SE. Asia and Indian Ocean:</li>
            <ul>
              <li>
                (Bangladesh,
                Bhutan,
                India,
                Indian Ocean,
                Myanmar (Burma),
                Nepal, Pakistan,
                Sri Lanka,
                Thailand,
                Vietnam)
              </li>
            </ul>
            <li>170 - Central and South Pacific:</li>
            <ul>
              <li>
                (Australia,
                Caroline Islands,
                Celebes Sea,
                Cook Islands,
                Fiji,
                French Polynesia,
                Guam,
                Indonesia,
                Kermadec Islands (New Zealand),
                Kiribati,
                Malaysia,
                Rep. of Marshall Islands,
                Fed. States of Micronesia,
                New Caledonia,
                New Zealand,
                Northern Mariana Islands,
                Pacific Ocean,
                Papua New Guinea,
                Philippines,
                Samoa,
                Solomon Islands,
                Solomon sea,
                South china sea,
                South Georgia and the South Sandwich Islands,
                Tasman Sea,
                Timor Sea,
                Tonga,
                Vanuatu)
              </li>
            </ul>
            <li>80 - Bering Sea</li>
            <li>50 - Kamchatka and Kuril Islands</li>
          </ul>
        </p>
      </p>
    </div>
  ),
};
